/**
 * Enter tuşu ile (textarea hariç) bir sonraki form alanına geçiş.
 * DevExtreme Form / TabbedItem ile uyumlu; DataGrid ve açık dropdown editörde Enter'ı olduğu gibi bırakır.
 */

function isTextAreaElement(el) {
    return !!(el && el.tagName === 'TEXTAREA');
}

function isInsideExcludedWidget(target) {
    if (!target || !target.closest) return true;
    if (target.closest('.dx-datagrid')) return true;
    if (target.closest('.dx-tagbox')) return true;
    if (target.closest('.dx-pivotgrid')) return true;
    if (target.closest('.dx-treelist')) return true;
    if (target.closest('.dx-button') && !target.closest('.dx-dropdowneditor')) return true;
    return false;
}

function isDropDownEditorOpen(target) {
    if (!target || !target.closest) return false;
    const dd = target.closest('.dx-dropdowneditor');
    if (!dd) return false;
    return (
        dd.classList.contains('dx-dropdowneditor-active') ||
        dd.getAttribute('aria-expanded') === 'true'
    );
}

function isVisibleInSubtree(el, root) {
    if (!root || !root.contains(el)) return false;
    let node = el;
    while (node && node !== root) {
        if (node.nodeType === 1) {
            const st = window.getComputedStyle(node);
            if (st.display === 'none' || st.visibility === 'hidden') return false;
        }
        node = node.parentElement;
    }
    return true;
}

function collectFocusables(root) {
    const selector = [
        'input:not([type="hidden"]):not([disabled])',
        'textarea:not([disabled])',
        'select:not([disabled])',
    ].join(',');
    const nodes = root.querySelectorAll(selector);
    const out = [];
    for (let i = 0; i < nodes.length; i++) {
        const el = nodes[i];
        if (el.tabIndex === -1) continue;
        if (!isVisibleInSubtree(el, root)) continue;
        if (isInsideExcludedWidget(el)) continue;
        out.push(el);
    }
    return out;
}

function resolveFocusableIndex(list, target) {
    let i = list.indexOf(target);
    if (i !== -1) return i;
    if (!target || !target.closest) return -1;
    const fieldItem = target.closest('.dx-field-item');
    if (fieldItem) {
        const hit = list.find((el) => fieldItem.contains(el));
        if (hit) return list.indexOf(hit);
    }
    return -1;
}

function focusNextLikeTab(el) {
    try {
        el.focus({ preventScroll: false });
    } catch (_) {
        return;
    }
    if (el.tagName !== 'INPUT') return;
    const t = (el.type || '').toLowerCase();
    if (
        t === 'text' ||
        t === 'search' ||
        t === 'tel' ||
        t === 'email' ||
        t === 'password' ||
        t === 'number' ||
        t === ''
    ) {
        try {
            el.select();
        } catch (_) {
            /* ignore */
        }
    }
}

/**
 * @param {HTMLElement} root
 * @returns {() => void} cleanup
 */
export function attachFormEnterToNextField(root) {
    if (!root || typeof root.addEventListener !== 'function') {
        return () => {};
    }

    const onKeyDownCapture = (e) => {
        if (e.key !== 'Enter') return;
        if (e.defaultPrevented) return;
        if (e.ctrlKey || e.metaKey || e.altKey) return;

        const target = e.target;
        if (!root.contains(target)) return;
        if (isInsideExcludedWidget(target)) return;
        if (isTextAreaElement(target)) return;
        if (isDropDownEditorOpen(target)) return;

        const list = collectFocusables(root);
        const idx = resolveFocusableIndex(list, target);
        if (idx === -1) return;
        if (idx >= list.length - 1) return;

        e.preventDefault();
        e.stopPropagation();
        focusNextLikeTab(list[idx + 1]);
    };

    root.addEventListener('keydown', onKeyDownCapture, true);
    return () => root.removeEventListener('keydown', onKeyDownCapture, true);
}
